module.exports = __webpack_public_path__ + "static/media/ni.21b2d20c.svg";